import "@/App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Benefits from "./components/Benefits";
import Certifications from "./components/Certifications";
import OurWork from "./components/OurWork";
import OnTheRoad from "./components/OnTheRoad";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import ServiceArea from "./components/ServiceArea";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-white text-[#1E293B]" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Benefits />
        <Certifications />
        <OurWork />
        <OnTheRoad />
        <Testimonials />
        <FAQ />
        <ServiceArea />
      </main>
      <Footer />
    </div>
  );
}

export default App;
